import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import store from '../../store';
import messages from '../../i18n';

import BundleOptions from '../../blocks/bundlePdp/BundleOptions';
import AddToCartBundlePdpContainer from '../../blocks/bundlePdp/AddToCartBundlePdpContainer';
import BundleBedFrameAOV from '../../blocks/bundlePdp/BundleBedFrameAOV/BundleBedFrameAOV';
import ProductTitleInfo from '../../blocks/bundlePdp/ProductTitleInfo';
import PromoBannerTracker from '../../blocks/PromoBannerTracker';
import { purpleTheme } from '../../themes/default';

const locale = 'en-US';

const containerTitle = document.getElementById('bundle-title-section');
if (containerTitle) {
  const rootTitle = createRoot(containerTitle);
  rootTitle.render(
    <IntlProvider
      messages={messages[locale]}
      locale={locale}
      defaultLocale="en"
    >
      <ThemeProvider theme={purpleTheme()}>
        <Provider store={store}>
          <ProductTitleInfo />
        </Provider>
      </ThemeProvider>
    </IntlProvider>,
  );
}

const containerOptions = document.getElementById('bundle-options');
if (containerOptions) {
  const rootOptions = createRoot(containerOptions);
  rootOptions.render(
    <IntlProvider
      messages={messages[locale]}
      locale={locale}
      defaultLocale="en"
    >
      <ThemeProvider theme={purpleTheme()}>
        <Provider store={store}>
          <BundleOptions />
        </Provider>
      </ThemeProvider>
    </IntlProvider>,
  );
}

const containerBedFrame = document.getElementById('bed-frame-aov');
if (containerBedFrame) {
  const rootBedFrame = createRoot(containerBedFrame);
  rootBedFrame.render(
    <IntlProvider
      messages={messages[locale]}
      locale={locale}
      defaultLocale="en"
    >
      <ThemeProvider theme={purpleTheme()}>
        <Provider store={store}>
          <BundleBedFrameAOV />
        </Provider>
      </ThemeProvider>
    </IntlProvider>,
  );
}

const containerAddToCart = document.getElementById('add-to-cart-section');
if (containerAddToCart) {
  const rootAddToCart = createRoot(containerAddToCart);
  rootAddToCart.render(
    <IntlProvider
      messages={messages[locale]}
      locale={locale}
      defaultLocale="en"
    >
      <ThemeProvider theme={purpleTheme()}>
        <Provider store={store}>
          <AddToCartBundlePdpContainer />
        </Provider>
      </ThemeProvider>
    </IntlProvider>,
  );
}

const containerBMSMTracker = document.getElementById('bmsm-tracker-block-pdp');
if (containerBMSMTracker) {
  const rootBMSMTracker = createRoot(containerBMSMTracker);
  rootBMSMTracker.render(
    <IntlProvider
      messages={messages[locale]}
      locale={locale}
      defaultLocale="en"
    >
      <ThemeProvider theme={purpleTheme()}>
        <Provider store={store}>
          <PromoBannerTracker hasEstimatedValue />
        </Provider>
      </ThemeProvider>
    </IntlProvider>,
  );
}
